/** @file cssToTarget: how many puppet-target pixels one CSS pixel spans in a viewport now. */
import { targetScreenOf } from './targetScreenOf';
import type { ViewportCtx } from './viewportCtx';

/** `dpr / scale` of `targetScreenOf` (device px per CSS px over the integer upscale); 1 before the canvas is fitted. */
export function cssToTarget(ctx: ViewportCtx): number {
  const l = ctx.camera?.layout() ?? null;
  if (l === null) return 1;
  const m = targetScreenOf(l);
  return m.dpr / m.scale;
}
